import React from 'react';
import { useSelector } from 'react-redux';
import { stepsSelector, totalStepsSelector } from '../../store/modules/steps/selectors';
import FormStepTitle from '../StepComponents/FormStepTitle';
import FormStepContent from '../StepComponents/FormStepContent';



const FormSteps: React.FC<any> = () => {

	const { steps, activeStepIndex: activeStep, formSubmitUrl } = useSelector(stepsSelector)
	const totalSteps = useSelector(totalStepsSelector)


	return (
		<div className={'o-service-order-booking-form-content-steps'}>
			<form action={formSubmitUrl} method='post' encType='multipart/form-data'>
				{steps?.map((step, stepIndex) => {
					return (stepIndex === activeStep
						&& <React.Fragment key={`form-step-${stepIndex}`}>
							<FormStepTitle {...{ step, currentStep: activeStep, totalSteps }} />
							<FormStepContent {...{ step }} />
						</React.Fragment>
					)
				})
				}
			</form>
		</div>
	);
};

export default FormSteps;
